import { DEFAULT_LANG } from "../../config/Constant";
import * as types from "../actions/LanguageList";

const initialState = {
  language: localStorage.getItem('lang') || DEFAULT_LANG,
  languageList: [],
  loading: false,
  error: null,
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_LANGUAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_LANGUAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        languageList: action.payload,
        error: null,
      };
    case types.FETCH_LANGUAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SET_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};

export default languageReducer;
